(function() {
  'use strict';

  angular
    .module('blocks.api', []);
})();
